import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { BellIcon } from 'lucide-react';
import { Header } from '../components/Header';
import { SignalGauge } from '../components/SignalGauge';
import { ReasoningCard } from '../components/ReasoningCard';
import { PortfolioFit } from '../components/PortfolioFit';
export function StockPage() {
  const reasoningData = [{
    title: 'Macro Climate',
    verdict: 'Positive',
    status: 'positive' as const,
    explanation: "Interest rates are easing and consumer spending is holding up. That's a tailwind for big tech right now.",
    defaultExpanded: true
  }, {
    title: 'Sector Position',
    verdict: 'Neutral',
    status: 'neutral' as const,
    explanation: "Tech is neither hot nor cold this quarter. Apple isn't leading the pack, but it's not falling behind either."
  }, {
    title: 'Company Fundamentals',
    verdict: 'Strong',
    status: 'positive' as const,
    explanation: 'Cash flow is excellent, margins are healthy, and services revenue keeps growing. The business engine is humming.'
  }, {
    title: 'Risk Factors',
    verdict: '2 Flagged',
    status: 'caution' as const,
    explanation: 'China sales are softening and regulatory scrutiny is rising. Worth watching, not panicking.'
  }, {
    title: 'Analyst Consensus',
    verdict: '7 Buy / 3 Hold',
    status: 'positive' as const,
    explanation: "Most analysts covering Apple lean bullish. A few are cautious, but nobody's calling it a sell."
  }];
  return <div className="min-h-screen bg-zinc-950 py-8 px-4" data-id="element-58">
      <div className="max-w-3xl mx-auto" data-id="element-59">
        <Header data-id="element-60" />

        <SignalGauge data-id="element-61" />

        <section className="mb-12" data-id="element-62">
          <h2 className="text-4xl font-semibold text-zinc-50 mb-6" style={{
          fontFamily: "'Instrument Serif', serif"
        }} data-id="element-63">
            Why?
          </h2>

          <motion.div className="space-y-3" initial="hidden" animate="visible" variants={{
          visible: {
            transition: {
              staggerChildren: 0.08
            }
          }
        }} data-id="element-64">
            {reasoningData.map((item, index) => <ReasoningCard key={index} {...item} data-id="element-65" />)}
          </motion.div>
        </section>

        <PortfolioFit data-id="element-66" />

        <div className="space-y-4" data-id="element-67">
          <button className="w-full bg-yellow-400 text-zinc-950 font-semibold py-4 px-6 rounded-lg hover:bg-yellow-300 transition-colors flex items-center justify-center gap-2" data-id="element-68">
            <BellIcon className="w-5 h-5" data-id="element-69" />
            Set price alert
          </button>

          <div className="text-center" data-id="element-70">
            <button className="text-zinc-400 text-sm hover:text-zinc-300 transition-colors" data-id="element-71">
              Or add to watchlist
            </button>
          </div>

          <p className="text-center text-xs text-zinc-600 mt-8" data-id="element-72">
            Not financial advice. Just a smart starting point.
          </p>
        </div>
      </div>
    </div>;
}